import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS
import './index.css';
import logoSrc from './img/logo.png';  // Add the correct path to the logo image
import LazyLoad from 'react-lazyload'; // Import LazyLoad

function Collaborations() {
  useEffect(() => {
    // Initialize AOS for animations
    AOS.init({
      duration: 1000, // Animation duration (in milliseconds)
      once: false, // Allow animations to trigger multiple times as you scroll
      mirror: true, // Allow animations to trigger on scroll-up
    });

    // Refresh AOS on scroll for dynamic content updates (if needed)
    window.addEventListener('scroll', () => {
      AOS.refresh();
    });

    // Cleanup event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', () => {
        AOS.refresh();
      });
    };
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text" data-aos="fade-up">
            <h1 className="banner-title" id='titulli'>partners in progress</h1>
            <p className="banner-description">
              At Shigjeta, we believe in the power of collaboration to achieve extraordinary results. By partnering
              with businesses, institutions, and organizations worldwide, we foster innovation, share knowledge, and
              open doors to new opportunities.
            </p>
            <a href="#sec2" className="banner-button">Explore Collaborations</a>
          </div>
          
        </div>
      </section>
      <div className='video-background'>
      <LazyLoad height={400} offset={100}>
      <video
      
              className="video"
              id='banner1-video'
              src="/video/ARROW COLLAB.mp4"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
              </LazyLoad>
      </div>
      <section className="about-section">
        {/* Section 1: Active Collaborations */}
        <div className="about-row" data-aos="fade-right">
          <div className="about-text" id='sec2'>
            <h2><strong>Our Current Partnerships</strong></h2>
            <p>
              We collaborate with leading companies, NGOs, and educational institutions to deliver impactful
              projects. These partnerships reflect our shared commitment to excellence, innovation, and growth.
            </p>
            <ul>
              <p><strong>Universum University:</strong> Talent development programs.</p>
              <p><strong>Discovery Lab:</strong> Content creation and media innovation.</p>
              <p><strong>Onitech:</strong> Tech-focused web and app development training.</p>
              <p><strong>NGOs:</strong> Social impact initiatives in education and youth empowerment.</p>
            </ul>
            <a href='mailto:contact@shigjeta.com' className="cta-button">Collaborate with us</a>
          </div>
          <div className="about-image" data-aos="fade-left">
            {/* Placeholder for an image */}
            <img src="img/pg5.1.png" alt="Universum University" />
          </div>
        </div>

        {/* Section 2: Benefits of Collaborating with Shigjeta */}
        <div className="about-row reverse" data-aos="fade-up">
          <div className="about-text">
            <h2><strong>Why Partner with Us?</strong></h2>
            <p>
              Our collaborations are built on trust, shared goals, and a commitment to delivering exceptional results.
              By partnering with Shigjeta, you gain access to our expertise, innovative solutions, and global network.
            </p>
            <ul>
              <p><strong>Access to Top Talent:</strong> Skilled professionals across branding, tech, and media.</p>
              <p><strong>Scalable Solutions:</strong> Flexible partnerships tailored to your needs.</p>
              <p><strong>Market Insights:</strong> Strategic data and trends through our global chambers.</p>
              <p><strong>Innovation Hub:</strong> Collaborative projects that foster new ideas and solutions.</p>
            </ul>
            <a href='/formular-contract' className="cta-button">Partner With Us</a>
          </div>
          <div className="about-image" data-aos="fade-left">
            {/* Placeholder for an image */}
            <img src="img/pg5.2.png" alt="Benefits of Collaboration" />
          </div>
        </div>

        {/* Section 3: Potential Collaborations */}
        <div className="about-row" data-aos="fade-right">
          <div className="about-text">
            <h2><strong>Opportunities for Future Partnerships</strong></h2>
            <p>
              We welcome collaborations across a variety of industries. Whether you’re a startup, established
              business, or NGO, let’s explore innovative solutions together and create mutual growth.
            </p>
            <ul>
              <li><strong>Renewable Energy:</strong> Partner with us to develop sustainable energy solutions.</li>
              <li><strong>FinTech:</strong> Innovate in digital finance with scalable tech solutions.</li>
              <li><strong>Retail:</strong> Improve customer engagement through digital transformation.</li>
              <li><strong>Education:</strong> Empower the next generation with digital tools and programs.</li>
              <li><strong>Agriculture:</strong> Support sustainable practices and advanced agri-tech solutions.</li>
              <li><strong>Media & Content Creation:</strong> Collaborate on visual storytelling, animations, and films.</li>
              <li><strong>Technology:</strong> Drive innovation in software, web, and app development.</li>
              <li><strong>Telemarketing & Sales:</strong> Join us to scale client outreach and customer acquisition.</li>
            </ul>
            <a href='/investIDEA' className="cta-button">Explore Opportunities</a>
          </div>
          <div className="about-image" data-aos="fade-left">
            {/* Placeholder for an image */}
            <img src="img/pg5.3.png" alt="Collaboration Opportunities" />
          </div>
        </div>

        {/* Section 4: Success Stories */}
        <div className="about-row reverse" data-aos="fade-up">
          <div className="about-text">
            <h2><strong>Collaborations That Deliver Results</strong></h2>
            <p>
              From education programs to global business partnerships, our collaborations have created tangible
              results. Discover how Shigjeta’s network has helped organizations achieve their goals.
            </p>
            <a href='/blog' className="cta-button">Read Collaboration Stories</a>
          </div>
          <div className="about-image" data-aos="fade-right">
            {/* Placeholder for an image */}
            <img src="img/pg5.4.png" alt="Success Stories" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Collaborations;
